import config from '@/config';
import Info from '@/geolocation/icons/Info';
import { isAndroidWrapper } from '@/utilities/helpers/wrapperHelpers';
import { useTranslation } from 'react-i18next';

const GeolocationErrorBody = () => {
  const isAndroid = isAndroidWrapper();

  const { t } = useTranslation();
  return (
    <>
      <p className="modal__header">
        {t('geocomply.locationError.description')}
      </p>
      <p>
        <Info />
        {t(
          `geocomply.locationError.${isAndroid ? 'androidWrapper.info1' : 'info1'}`,
        )}
      </p>
      <p>
        <Info />
        {t(
          `geocomply.locationError.${isAndroid ? 'androidWrapper.info2' : 'info2'}`,
        )}
      </p>
      <p>
        <Info />
        {t('geocomply.locationError.info3')}
        <a
          className="more-details"
          href={config?.geoComply?.help}
          target="_blank"
          rel="noopener noreferrer"
        >
          {t('geocomply.locationError.link')}
        </a>
      </p>
    </>
  );
};

export default GeolocationErrorBody;
